import * as Sentry from '@sentry/react';

export function initSentry() {
  // eslint-disable-next-line no-undef
  const dsn = process.env.REACT_APP_SENTRY_DSN;

  if (!dsn) {
    // eslint-disable-next-line no-undef
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn('[Sentry] DSN ausente (REACT_APP_SENTRY_DSN), init pulado.');
    }
    return;
  }

  Sentry.init({
    dsn,
    // eslint-disable-next-line no-undef
    environment:
      // eslint-disable-next-line no-undef
      process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
    // eslint-disable-next-line no-undef
    release: process.env.REACT_APP_SENTRY_RELEASE,
    tracesSampleRate: 0,
    integrations: [],
  });
}
